import $ from "jquery"
import DelayTooltip from "../controls/DelayTooltip"
import {escapeHtmlSymbols} from "../atUtils"
import {calculateTooltipOffset} from "../atBrowserUtils"
import {DateFormat} from "../date_format"
import ChartPDFViewer from "../reports/charts/pdfpreview/ChartPDFViewer"

const PDFPreviewController = function() {};

PDFPreviewController.prototype = {
    init: function(lightBoxEl, titleEl, lightboxId)
    {
        var self = this;
        this.lightBoxEl = lightBoxEl;
        this.titleEl = titleEl;
        this.chartConfigurationSection = $(document.getElementById(lightboxId + "_chartConfigurationSection"));

        this._initPdfSettingsPreview(lightboxId);

        this.pdfViewer = new ChartPDFViewer().init();

        // date format for lightbox title and pdf preview
        this.dateFormat = this._getDateFormatForPreviewSection();

        this.titleTooltip = new DelayTooltip().init(lightboxId + "_titleTooltip");
        this.titleTooltip.updateUI = function(text) { this._tooltipTextPlaceholder.html(escapeHtmlSymbols(text)); };

        this.downloadPDFBtn = $(document.getElementById(lightboxId + "_downloadPdfBtn"));
        this.downloadPDFBtn.off();
        this.downloadPDFBtn.click(function() { self.onDownloadPDFBtnClicked() });

        this._subscribeForEvents();

        return this;
    },

    _initPdfSettingsPreview: function()
    {
        // Abstract
    },

    _subscribeForEvents: function()
    {
        // Abstract
    },

    cancelAllExportingProcesses: function()
    {
        // Abstract
    },

    _setTitle: function(formattingStrategy, selectedParameters)
    {
        var self = this;
        var titleMainPart = formattingStrategy.formatMainPartOfLightboxTitle(selectedParameters);
        var titleMainPartSpan = $(document.createElement("span"));
        titleMainPartSpan.text(titleMainPart);

        var titleSpecifyingPart = formattingStrategy.formatSpecifyingPartOfLightboxTitle(selectedParameters);
        var specifyingPartSpan = $(document.createElement("span"));
        specifyingPartSpan.text(titleSpecifyingPart);
        specifyingPartSpan.addClass("specifyingPart");

        this.titleEl.empty().append(titleMainPartSpan).append(specifyingPartSpan);
        this.titleEl.off( "mousemove" );
        this.titleEl.off( "hover" );
        if( this.titleEl.outerWidth() < this.titleEl[0].scrollWidth )
        {
            this.titleEl.hover(
                    function( event )
                    {
                        self.titleTooltip.updateUIAndShow( titleMainPart + titleSpecifyingPart, calculateTooltipOffset( self.titleTooltip, event ) );
                    },
                    function() { self.titleTooltip.hide() }
            );
            this.titleEl.mousemove(
                    function( event ) { self.titleTooltip.move( calculateTooltipOffset( self.titleTooltip, event ) ); }
            )
        }

        this.chartConfigurationSection.text(formattingStrategy.formatParametersText(selectedParameters));
    },

    onDownloadPDFBtnClicked: function()
    {
        // Abstract
    },

    disableDownloadPDFButton: function()
    {
        this.downloadPDFBtnEnabled = false;
        this.downloadPDFBtn.addClass("disabled");
    },

    enableDownloadPDFButton: function()
    {
        this.downloadPDFBtnEnabled = true;
        this.downloadPDFBtn.removeClass("disabled");
    },

    onGeneratePDFCompleted: function()
    {
        // Abstract
    },

    /**
     * Get date format depends on system setting but in short version (year in format yy, month in format MMM)
     * @private
     */
    _getDateFormatForPreviewSection: function() {
        var dateFormat = window.SystemSettings.dateFormat;
        dateFormat = dateFormat.replace(/MMMM/, 'MMM');
        dateFormat = dateFormat.replace(/yyyy/, 'yy');
        return new DateFormat(dateFormat);
    }
};

export default PDFPreviewController


// WEBPACK FOOTER //
// ./web/js/pdfPreview/PDFPreviewController.js